import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-6 rounded-full bg-accent-500" />
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            {title}
          </h2>
        </div>
        {subtitle && (
          <p className="mt-2 text-sm text-foreground-600 pl-[18px]">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 text-sm text-foreground-600 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}